<template>
  <div class="distributor-system-set">
    <div class="common-header-wrap">
      <mt-header title="System settings" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div>
      <div class="form-wrapper">
        <mt-cell title="Support self-pickup" v-if="chain.store_id">
          <mt-switch v-model="chain.chain_if_pickup"/>
        </mt-cell>
        <mt-cell title="Support collection" >
          <mt-switch v-model="chain.chain_if_collect"/>
        </mt-cell>
      </div>
      <div class="form-wrapper">
          <mt-field label="Collection point name" v-model="chain.chain_addressname"></mt-field>
          <div @click="onRegion()"><mt-cell title="Location" is-link>{{chain.chain_area_info}}</mt-cell></div>
          <div @click="popMap=true"><mt-cell title="Address" is-link>{{chain.chain_address}}</mt-cell></div>
          <mt-field label="Contact phone" v-model="chain.chain_mobile"></mt-field>
          <mt-field label="Fixed telephone" v-model="chain.chain_telephony"></mt-field>
      </div>
    </div>
    <mt-button class="menu-btn" type="primary" size="large" @click="updateSet">Save</mt-button>
    <div>
        <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
    </div>
    <div>
        <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="Location" class="common-header">
                    <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <map-select ref="map_select" :longitude="chain.chain_longitude" :latitude="chain.chain_latitude" @setPosition="setPosition"></map-select>
            </div>
        </mt-popup>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import RegionPicker from '../../RegionPicker'
import MapSelect from '../../MapSelect'
import { chainInformation, chainSetting } from '../../../api/chainManage'
import { getPointByAddress } from '../../../util/bmap'
export default {
  components: {
    RegionPicker,
    MapSelect
  },
  name: 'ChainSetting',
  data () {
    return {
      chain: {},
      popMap: false
    }
  },
  mounted () {

  },
  created: function () {
    chainInformation().then(res => {
      this.chain = res.result.chain_info
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint'
    }),
    ...mapMutations({
      chainUpdate: 'chainUpdate'
    }),
    updateSet () {
      chainSetting(this.chain).then(res => {
        this.chainUpdate({ info: res.result.info })
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },

    setPosition (lat, lng, name) {
      this.popMap = false
      this.chain.chain_address = name
      this.chain.chain_longitude = lng
      this.chain.chain_latitude = lat
      this.$forceUpdate()
    },
    onPickerConfirm (values) {
      this.chain.chain_area_info = this.getRegionStr(values)
      this.chain.chain_area_2 = values[1] ? values[1].area_id : 0
      this.chain.chain_area_3 = values[2] ? values[2].area_id : 0
      this.selectCity(values.length > 1 ? values[1].area_name : values[0].area_name)
      this.$forceUpdate()
    },
    onRegion () {
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    selectCity (city_name) {
      getPointByAddress(city_name).then(res => {
        if (res.result.location) {
          var lng = res.result.location.lng
          var lat = res.result.location.lat
          this.chain.chain_latitude = lat
          this.chain.chain_longitude = lng

          this.memberPoint({ point: { lng: lng, lat: lat, address: res.result.formatted_address, cityCode: res.result.cityCode, cityName: city_name } })
          // this.$forceUpdate()
        } else {
          Toast('Unable to get city location')
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
  .distributor-system-set {
    background: #fff;
    .form-wrapper {
      border-bottom: 1px solid #eee;
      .mint-field-core {
        text-align: right;
      }
      .mint-switch-input:checked + .mint-switch-core {
        border-color: #ff9900 !important;
        background-color: #ff9900 !important;
      }
      .mint-radiolist-title {
        margin: 0 !important
      }
      .mint-radiolist {
        display: flex;
        .mint-cell {
          flex: 1;
          .mint-radio-input:checked + .mint-radio-core {
            background-color: #ff9900 !important;
            border-color: #ff9900 !important;
          }
        }
      }
    }
    .notice {
      font-size: .6rem;
      color: #999;
      padding: .5rem;
      p {
        position: relative;
        padding-left: .5rem;
      }
      p::before {
        position: absolute;;
        content: '';
        width: .3rem;
        height: .3rem;
        border-radius: 50%;
        background: #ddd;
        display: block;
        top: 50%;
        margin-top: -.15rem;
        left: -.25rem
      }
    }
  }

</style>
